import { Row } from 'app/design/primitives/box';

import { useDeviceHeight } from 'app/hooks/use-device-size';
import React from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const popperShadowStyle = {
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
} as const;

export function Popper({
  align = 'right',
  children,
  withScrollableContent = false,
  minWidth = 400,
}: {
  align?: 'left' | 'right';
  children: React.ReactNode;
  withScrollableContent?: boolean;
  minWidth?: number;
}) {
  const deviceHeight = useDeviceHeight();

  return (
    <Row
      flex={1}
      backgroundColor="white"
      position="absolute"
      top={50}
      left={align === 'left' ? 0 : undefined}
      right={align === 'right' ? 0 : undefined}
      zIndex={9999}
      width="auto"
      minWidth={minWidth}
      maxWidth={800}
      height="auto"
      borderRadius="radius.lg"
      maxHeight={withScrollableContent ? deviceHeight - 200 : undefined}
      paddingHorizontal={withScrollableContent ? undefined : 'spacing.general.x4'}
      paddingVertical={withScrollableContent ? undefined : 'spacing.general.x2'}
      style={
        withScrollableContent
          ? popperShadowStyle
          : { ...popperShadowStyle, paddingVertical: theme.spacing['spacing.general.x8'] - 6 }
      }
    >
      {withScrollableContent ? (
        <ScrollView
          showsVerticalScrollIndicator
          style={{
            paddingVertical: theme.spacing['spacing.general.x8'] - 6,
            paddingHorizontal: theme.spacing['spacing.general.x4'],
            maxHeight: deviceHeight - 100,
          }}
        >
          {children}
        </ScrollView>
      ) : (
        children
      )}
    </Row>
  );
}
